import { AddInventoryItemPage } from 'pages/inventory/add';

export const AddInventoryItemView = () => {
  return <AddInventoryItemPage />;
};
